import GLightbox from 'glightbox';
window.GLightbox = GLightbox;

document.addEventListener('DOMContentLoaded', function () {
	GLightbox({
		selector: '.glightbox',
		loop: true,
	});
});
